import React, { useRef } from 'react';
import './Video.css'; // Import the CSS file for styles

const Video = () => {
  const videoContainerRef = useRef(null); // Reference to the video container
  const videos = [
    {
      url: "https://www.youtube.com/embed/0azpEhFtIYQ",
      title: "HVLS Fans",
      link: "https://www.youtube.com/watch?v=0azpEhFtIYQ",
    },
    {
      url: "https://www.youtube.com/embed/tN4zucCIToc",
      title: "Yamota Machine",
      link: "https://www.youtube.com/watch?v=tN4zucCIToc",
    },
    {
      url: "https://www.youtube.com/embed/qmYIpcvc5FU",
      title: "Automatic Textile Machine",
      link: "https://www.youtube.com/watch?v=qmYIpcvc5FU",
    },
    {
      url: "https://www.youtube.com/embed/g1zYsxW0Nbo",
      title: "SSKV Aircooler Ducts",
      link: "https://www.youtube.com/watch?v=g1zYsxW0Nbo",
    },
  ];

  const handleDotClick = (index) => {
    // Scroll to the clicked video
    const videoItem = videoContainerRef.current.children[index];
    if (videoItem) {
      videoItem.scrollIntoView({ behavior: 'smooth', inline: 'start' });
    }
  };

  return (
    <section className="video-section">
      <h2 className="video-title">Our Video Gallery</h2>
      <p className="video-description">
        Explore our latest projects and innovations through our videos.
      </p>
      <div className="video-container" ref={videoContainerRef}>
        {videos.map((video, index) => (
          <div className="video-item" key={index}>
            <a href={video.link} target="_blank" rel="noopener noreferrer">
              <iframe 
                src={video.url} 
                title={video.title} 
                allowFullScreen 
                className="video-iframe"
              />
              <div className="video-overlay">{video.title}</div>
            </a>
          </div>
        ))}
      </div>
      {/* <div className="navigation-dots">
        {videos.map((_, index) => (
          <span 
            key={index} 
            className="dot" 
            onClick={() => handleDotClick(index)} // Click event to scroll to video
          ></span>
        ))}
      </div> */}
    </section>
  );
};

export default Video;
